exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selectBorder[data-v-5d5b146d]  .el-input__inner{border:none}.selectBorder input[data-v-5d5b146d]::-webkit-input-placeholder{color:red}.selectBorder input[data-v-5d5b146d]::-moz-placeholder{color:red}.selectBorder input[data-v-5d5b146d]:-ms-input-placeholder{color:red}.selectBorder input[data-v-5d5b146d]::-ms-input-placeholder{color:red}.selectBorder input[data-v-5d5b146d]::placeholder{color:red}.test[data-v-5d5b146d]  .el-radio-button__inner{background:none;border:none;color:red}", ""]);

// exports
